import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/Header/eeg.png';
import _imports_1 from '../../assets/img/Header/x.png';
const _withScopeId = n => (_pushScopeId("data-v-6399cd36"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_2 = {
  class: "nav"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "links"
}, [/*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://x.com/BeingcomApp"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})])], -1));
const _hoisted_4 = ["src"];
import zh from "../../assets/img/Header/lang-zh.png";
import en from "../../assets/img/Header/lang-en.png";
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
export default {
  __name: 'index',
  setup(__props) {
    const className = ref("");
    const {
      locale
    } = useI18n();
    const store = useStore();
    const langImg = {
      zh,
      en
    };
    const lang = computed(() => {
      return store.state.lang;
    });
    function changeLangs(value) {
      if (value == "zh-CN") {
        locale.value = "en-US";
        store.commit("updateLang", "en-US");
      } else {
        locale.value = "zh-CN";
        store.commit("updateLang", "zh-CN");
      }
    }
    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });
    function handleScroll() {
      if (document.documentElement.clientWidth > 600) {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 100) {
          className.value = "bgWhite";
        } else {
          className.value = "delBgWhite";
        }
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['header-index', 'header-index-' + _unref(lang), className.value])
      }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
        class: "langs",
        onClick: _cache[0] || (_cache[0] = $event => changeLangs(_unref(lang)))
      }, [_createElementVNode("img", {
        src: _unref(lang) === 'zh-CN' ? langImg.zh : langImg.en,
        alt: ""
      }, null, 8, _hoisted_4)])])], 2);
    };
  }
};